import React from "react";
import NavigationSearch from "Components/App/NavigationSearch";

export default function Module(props) {

    const x = props.x;

	const [display, setDisplay] = React.useState(props.display);
	const [isFavorite, setIsFavorite] = React.useState(x.wam.isFavorite(props.id));

	const displayTitle = (typeof props.displayTitle === 'undefined') ? '' : props.displayTitle;
	const classes = (typeof props.classes != 'undefined') ? props.classes : '';
	const isForumModule = x.wam[props.id].moduleType === 'forum';

	function toggleFavorite() {
		x.wam.toggleFavorite(props.id, setIsFavorite);
	}


	x.wam.init(props.id, {
		"title": props.title
	});

	x.wam[props.id].hide = hide;
	x.wam[props.id].show = show;

	function hide() {
		setDisplay('d-none');
	}

	function show() {
		setDisplay('d-box');
		if (typeof props.onShow !== 'undefined') props.onShow();
	}

	function closeModule() {
		x.was.removeModule(props.id);
		x.wam.activate('forum');
	}

	function makeContent() {
		let content = {};
		let close = {};
		const moduleTitleTag = <NavigationSearch x={x} variant="compact" triggerLabel={props.title} />;

		const favoriteIconTag = !isForumModule &&
			<span
				className={`bi ${isFavorite ? 'bi-star-fill' : 'bi-star'} module-favorite-icon`}
				title={isFavorite ? 'Als Favorit entfernen' : 'Als Favorit merken'}
				onClick={toggleFavorite}
			/>;

		if (typeof props.closeButton === 'undefined' || props.closeButton ) {
			close = <i className={`bi bi-x-square module-icon module-close`} title="Schließen" onClick={e => closeModule()} />
		}
		else {
			close = <i className={`bi bi-x-square module-icon module-icon-disabled`} title="Schließen nicht möglich: Hauptmodul"   />
		}
		content =
			<div key={"module-frame-" + props.id} id={"module-frame-" + props.id} className={` webapp-module module-frame ${classes} ${display} `}>
				<div key={'module-title-' + props.id} id={'module-title-' + props.id} className={` module-head ${displayTitle}`}>
					<span className='module-head-title '>
						<span className='module-title' >
							{moduleTitleTag}
							{favoriteIconTag}
						</span>
					</span>
					{props.toolbar}
					<span className='module-head-right'>
						{close}
						{props.titleToolbar}
					</span>
				</div>
				<div key={"module-content-" + props.id} id={"module-content-" + props.id} className={` module-content  `} >
					{props.children}
				</div>
			</div>
		return content;
	}

	return (
		<React.Fragment>
			{ makeContent() }
		</React.Fragment>
	)

};

